import readDnaConfigByActiveProgram from './readDnaConfigByActiveProgram';

export const isBillPaymentEnabled = () => {
  const dnaConfig = readDnaConfigByActiveProgram();

  return dnaConfig?.bill_pay?.service_enabled;
};
